
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["check-circle-outline",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_1256","data-name":"Group 1256","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_1246","data-name":"Path 1246","d":"M8 0a8 8 0 108 8 8.009 8.009 0 00-8-8zm0 14.545A6.545 6.545 0 1114.545 8 6.553 6.553 0 018 14.545z","fill":"#70cc0a"}}),_c('path',{attrs:{"id":"Path_1247","data-name":"Path 1247","d":"M84.129 102.505l-3.754 4.52-1.721-2.072a.588.588 0 00-.939 0 .918.918 0 000 1.13l2.19 2.637a.612.612 0 00.469.234.613.613 0 00.469-.234l4.224-5.085a.918.918 0 000-1.13.587.587 0 00-.938 0z","transform":"translate(-73.392 -97.613)","fill":"#70cc0a"}})])
          )
        }
      }
    